export interface CapabilityDimension {
  id: string;
  continuityId: string;
  name: string;
  description: string | null;
  position: number;
  idealScore: number | null;
  positiveIndicators: string | null;
  negativeIndicators: string | null;
  successCriteria: string | null;
  coveredBriefFields: string[];
}

// Structured brief fields a capability dimension can declare it covers.
// Kept in lockstep with `Campaigns::BriefCoverageReport::IN_SCOPE_FIELDS`
// on the Ruby side.
export const BRIEF_FIELD_LABELS: Record<string, string> = {
  role_mandate: "Role mandate",
  context_notes: "Context",
  success_outcomes: "Success outcomes",
  cultural_fit_notes: "Cultural fit",
  motivation_fit_notes: "Motivation fit",
  assessment_process: "Assessment process",
  background_check_requirements: "Background checks",
};

export function labelForBriefField(field: string): string {
  return BRIEF_FIELD_LABELS[field] ?? field;
}

export interface Persona {
  id: string;
  name: string;
  summary: string | null;
  description: string | null;
  position: number;
}

export interface BlueprintVersion {
  id: string;
  versionNumber: number;
  effectiveFrom: string;
  effectiveTo: string | null;
  changeSummary: string | null;
  superseded?: boolean;
  // Only selected by the `versions` path in ROLE_BLUEPRINT_QUERY (historical
  // viewing). `currentVersion` omits it because the separate
  // CapabilityDimensionsEditor section renders the live set from
  // blueprint.capabilityDimensions.
  capabilityDimensions?: CapabilityDimension[];
}

export interface LockPrecondition {
  key: string;
  label: string;
  met: boolean;
  detail: string | null;
}

export interface LockEvent {
  id: string;
  kind: "locked" | "unlocked" | "generated";
  versionNumber: number | null;
  occurredAt: string;
  actor: { id: string; name: string } | null;
  reason: string | null;
}

export interface OutOfSyncArtefact {
  id: string;
  kind: "screening_criteria" | "interview_guide" | "assessment_matrix" | "candidate_scoring_matrix";
  name: string;
  pinnedVersionId: string | null;
  currentBlueprintVersionId: string | null;
}

export interface LinkedBlueprintArtefact {
  id: string;
  kind: OutOfSyncArtefact["kind"];
  name: string;
  pinnedVersionId: string | null;
  pinnedVersionNumber: number | null;
  currentBlueprintVersionId: string | null;
  currentBlueprintVersionNumber: number | null;
  outOfSync: boolean;
}
